export default {
  findPlan: 'Encontremos un plan para tu escuela:',
  freemium: 'Licencia Freemium',
  byProgram: 'Licencia por programas',
  campus: 'Licencia campus',
  accessDuration: 'Duración de acceso',
  oneYear: 'Anual',
  amountOfUsers: 'Cantidad de usuarios',
  unlimited: 'Ilimitados',
  userAdministration: 'Administración de usuarios y roles',
  contentAccess: 'Acceso a contenido',
  freemiumContent: 'Contenido freemium',
  byProgramContent: 'Contenido freemium + programas seleccionados',
  fullAccess: 'Contenido completo',
  licensesMetrics: 'Métricas',
  folders: 'Carpetas personalizadas',
  fee: 'Fee',
  free: 'Gratis',
  metrics: 'Métricas de Aprendizaje',
  withQuote: 'Con cotización',
  continueAsFreemium: 'Continuar como freemium',
  quoteLicense: 'Cotizar licencia',
  applicant: 'Quién lo solicita',
  teacherAndSchool: 'Educadores y/o centros escolares',
  schools: 'Centros escolares',
  currentLicense: 'Licencia actual',
  freemiumConfirmationModal: {
    title: 'Ya casi estamos!',
    text: '<span class="text-normal">Al presionar continuar se asignará la licencia <span class="text-normal bold">freemium</span> a todas las cuentas que participaron del trial y obtendrán los permisos y accesos especificados en dicha licencia</span>',
    continue: 'Continuar',
    cancel: 'Cancelar',
    freemiumAccount: '¡Tu cuenta ha sido actualizada!',
    freemiumDescription: 'Ya puedes navegar por los recursos freemium e implementarlos con tus grupos',
    goToHome: 'Explorar recursos'
  }
}

export const en = {
  findPlan: 'Let\'s find a plan for your school:',
  freemium: 'Freemium license',
  byProgram: 'License by program',
  campus: 'Campus license',
  accessDuration: 'Access duration',
  oneYear: 'Anual',
  amountOfUsers: 'Amount of users',
  unlimited: 'Unlimited',
  userAdministration: 'User and roles administration',
  contentAccess: 'Content access',
  freemiumContent: 'Freemium content',
  byProgramContent: 'Freemium content + selected programs',
  fullAccess: 'Full access',
  licensesMetrics: 'Metrics',
  folders: 'Folders',
  fee: 'Fee',
  free: 'Free',
  metrics: 'Metrics',
  withQuote: 'With quote',
  continueAsFreemium: 'Continue as freemium',
  quoteLicense: 'Quote license',
  applicant: 'Applicant',
  teacherAndSchool: 'Teachers and school centre',
  schools: 'School centre',
  currentLicense: 'Current License',
  freemiumConfirmationModal: {
    title: 'Get my freemium license',
    text: ' <span class="text-normal">Clicking on continue will assign the <span class="text-normal bold"> freemium </span>license to all accounts that participated in the trial, and they all will get the permissions and access specified in the license.</span>',
    continue: 'Continue',
    cancel: 'Cancel',
    freemiumAccount: 'Your account has been successfully updated',
    freemiumDescription: 'You can navigate freemium resources and implement them with your groups',
    goToHome: 'Explore resources'
  }
}

export const ca = {
  findPlan: 'Trobem un pla per a la teva escola:',
  freemium: 'Llicència Freemium',
  byProgram: 'Llicència per programes',
  campus: 'Llicència Campus',
  accessDuration: 'Durada de l\'accés',
  oneYear: 'Anual',
  amountOfUsers: 'Nombre d\'usuaris',
  unlimited: 'Il·limitats',
  userAdministration: 'Administració d\'usuaris i rols',
  contentAccess: 'Accés al contingut',
  freemiumContent: 'Contingut freemium',
  byProgramContent: 'Contingut freemium + programes seleccionats',
  fullAccess: 'Contingut complet',
  licensesMetrics: 'Mètriques',
  folders: 'Carpetes personalitzades',
  fee: 'Quota',
  free: 'Gratuïta',
  metrics: 'Mètriques d\'Aprenentatge',
  withQuote: 'Amb cotització',
  continueAsFreemium: 'Continua com a freemium',
  quoteLicense: 'Cotitzar llicència',
  applicant: 'Qui ho sol·licita',
  teacherAndSchool: 'Educadors i/o centres escolars',
  schools: 'Centres escolars',
  currentLicense: 'Llicència actual',
  freemiumConfirmationModal: {
    title: 'Ja gairebé estem!',
    text: '<span class="text-normal">Al fer clic a continuar s\'assignarà la llicència <span class="text-normal bold">freemium </span> a tots els comptes que han participat en la prova, i obtindran els permisos i l\'accés que s\'especifiquen a la llicència.</span>',
    continue: 'Continua',
    cancel: 'Cancel·la',
    freemiumAccount: 'El teu compte s\'ha actualitzat!',
    freemiumDescription: 'Ja pots navegar pels recursos freemium i implementar-los amb els teus grups',
    goToHome: 'Explora recursos'
  }
}
